/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_BodyInputs */

const en_services_delivery_body = /** @type {(inputs: Services_Delivery_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We agree how the system should be tested, operated and improved. A useful first version comes with a plan for the day after launch.`)
};

const lv_services_delivery_body = /** @type {(inputs: Services_Delivery_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs vienojamies, kā sistēma tiks pārbaudīta, darbināta un uzlabota. Noderīgai pirmajai versijai līdzi nāk plāns nākamajai dienai pēc ieviešanas.`)
};

/**
* | output |
* | --- |
* | "We agree how the system should be tested, operated and improved. A useful first version comes with a plan for the day after launch." |
*
* @param {Services_Delivery_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_body = /** @type {((inputs?: Services_Delivery_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_body(inputs)
	return en_services_delivery_body(inputs)
});